import { render, staticRenderFns } from "./customerTable.vue?vue&type=template&id=7ca5bc12&"
import script from "./customerTable.vue?vue&type=script&lang=js&"
export * from "./customerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports